import { t } from "i18next";

import { Notice } from "emoreg/atoms/Notice";
import { Typography } from "emoreg/atoms/Typography";

export const XimiMigrationWarningAtConnection = () => {
  return (
    <Notice type="orange">
      <Typography as="span" fontWeight={600}>
        Le système sera en maintenance le 11 juillet !
      </Typography>
      <br />
      Ximi déplace nos données pour accélérer notre système :
      <ul>
        <li>La déclaration d'absence sur l'application {t("caregiver_short")} sera désactivée.</li>
        <li>En fin de journée, Hassibot sera complètement hors-service pendant quelques heures.</li>
      </ul>
    </Notice>
  );
};

export const XimiMigrationWarning = () => {
  return (
    <Notice type="orange">
      <Typography as="span" fontWeight={600}>
        Le système sera en maintenance le 11 juillet !
      </Typography>
      <br />
      Ximi déplace nos données pour accélérer notre système. La déclaration d'absence sur
      l'application {t("caregiver_short")} sera désactivée. En fin de journée, Hassibot sera
      complètement hors-service pendant quelques heures.
    </Notice>
  );
};
